// extracted by mini-css-extract-plugin
export default {"alertLoader":"Loading_alertLoader__pqKDC","loadingText":"Loading_loadingText__3+pnw"};